const cleanEventName = (event) => {
    return event.toLowerCase().replace(/ |_/g, '-');
};

export const hotJarTrigger = (eventTrigger) => {
    if (window.hj) {
        window.hj('trigger', cleanEventName(eventTrigger));
    }
};
